module.exports = __webpack_public_path__ + "img/162.dc183a88.jpg";